import React from 'react';
import { useTranslation } from 'react-i18next';
import Tip from '../Tip/Tip';
import styles from './sass/StakeholderTips.module.scss';

const TipStakeholderFunctionalTrigger = () => {
  const { t } = useTranslation();

  return (
    <Tip
      styleTipTextContainer={`${styles.triggerContainer} ${styles.functionalContainer}`}
      styleTriangle={styles.triangle}
    >
      <p>
        {t('tipStakeholderFunctionalTrigger')}
      </p>
    </Tip>
  );
};

export default TipStakeholderFunctionalTrigger;
